import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import moment from 'moment';
import { Edit, Trash } from 'lucide-react';
import BtnSpinner from '../../components/BtnSpinner';
import Pagination from '../../components/Pagination';
import { Apirequests } from '../../utils/ApiRequests';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import AddOrEditLesson from './AddOrEditLesson';
import LessonDetails from './LessonDetails';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import Comments from './Comments';

function Lessons() {

    const { course_id, chapter_id } = useParams();

    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
    const [lessons, setLessons] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState({ state: false, name: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [currentLesson, setCurrentLesson] = useState(null);
    const [deleteId, setdeleteId] = useState(null);
    const [viewComments, setViewComments] = useState({state:false,lessonId:null});

    const token = localStorage.getItem("token");

    const totalItems = lessons?.length; // Total number of items
    const itemsPerPage = 20;

    const currentData = lessons?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // console.log(viewComments,'viewComments')

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const navigate = useNavigate();

    const handleRefresh = () => setRefresh(!refresh);

    const fetchLessons = async () => {
        setLoading({ state: true, name: "fetchlessons" });

        try {
            const lesres = await Apirequests(`lesson/get-lessons`, 'GET', {}, {
                Authorization: `Bearer ${token}`,
                chapter_id: chapter_id,
                course_id: course_id
            });
            // console.log(lesres, 'lesres')
            if (lesres.success) {
                setLessons(lesres.data)
            }
        } catch (error) {
            console.log(error, 'fetch lesson error')
        }

        setLoading({ state: false, name: "" });
    }

    const handleDeleteLesson = async (id) => {
        setdeleteId(id);
        setLoading({state:true,name:"deletelesson"});

        try {
            const delLes= await Apirequests(`lesson/delete-lesson/${id}`,'DELETE',{},{
                Authorization:`Bearer ${token}`,
                chapter_id: chapter_id
            });

            if(delLes?.success){
                SuccessTost(delLes?.message);
                setRefresh(!refresh)
            }else{
                ErrorTost(delLes?.message)
            }
        } catch (error) {
            console.log(error,'lesson delete error');
            ErrorTost("Something went wrong, please try again later")
        }
        setLoading({state:false,name:""})
    }

    useEffect(() => {
        fetchLessons()
    }, [token, refresh, chapter_id, course_id])


    if (loading.state && loading.name === "fetchlessons") {
        return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
            <SpinningLogo />
        </div>
    }


    return (
        <div>
            <CustomPageHeader
                title={`Lessons of ${course_id}/${chapter_id}`}
                text={searchTerm}
                setText={setSearchTerm}
                handleSearch={() => console.log(searchTerm)}
                onClick={() => setIsOffCanvasOpen({ state: true, name: "addlesson" })}
                btnText={"Add Lesson"}
                handleBackClick={() => navigate(`/${course_id}/chapters`)}
                handleRefresh={handleRefresh}
                handleDownload={() => downloadExcel(lessons, 'lessons')}
            />

            <main className="mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 py-6 sm:px-0">
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white">
                            <thead className="bg-gray-50 text-center">
                                <tr>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Lesson Id</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Lesson Type</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Lesson Title</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">AccessType</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Comments</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 text-center">
                                {currentData?.map((lesson) => (
                                    <tr key={lesson._id}>
                                        <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setCurrentLesson(lesson); setIsOffCanvasOpen({ state: true, name: "viewlesson" }) }}>{lesson?.lessonId}</span></td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lesson?.fileType}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lesson?.title}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lesson?.access_type}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-indigo-600 cursor-pointer" onClick={()=>setViewComments({state:true, lessonId: lesson?._id})}>Comments</td>
                                        <td className="px-6 py-4 whitespace-nowrap"><span className={`px-2 py-1 rounded-lg ${lesson?.status === "Active" ? "bg-green-200 text-green-500" : "bg-red-200 text-red-500"}`}>{lesson?.status}</span></td>
                                        <td className="px-6 py-4 whitespace-nowrap">{moment(lesson?.createdAt).format("DD-MM-YY")}</td>
                                        <td className="px-6 py-4 flex gap-5 justify-center">
                                            <button className='flex bg-indigo-400 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editlesson" }); setCurrentLesson(lesson) }}>
                                                <Edit className='text-white' size={20} />
                                                <span className='text-white text-sm'>Edit</span>
                                            </button>
                                            <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => handleDeleteLesson(lesson?.lessonId)}>
                                                {
                                                    loading.state && loading.name === "deletelesson" && deleteId === lesson?.lessonId ?
                                                        <BtnSpinner /> :
                                                        <>
                                                            <Trash className='text-red-700 text-sm' size={20} />
                                                            <span className='text-red-700 text-sm'>Delete</span>
                                                        </>
                                                }

                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {lessons?.length ?
                    <div className="flex gap-x-2 items-center justify-between">
                        <p>total: {lessons?.length}</p>
                        <Pagination
                            page={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={handlePageChange}
                        />
                    </div> : null}
            </main>

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addlesson"}
                close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                content={
                    <AddOrEditLesson
                        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                        setRefresh={setRefresh}
                        lesson={currentLesson}
                    />
                }
            />

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "editlesson"}
                close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentLesson(null) }}
                content={
                    <AddOrEditLesson
                        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentLesson(null) }}
                        setRefresh={setRefresh}
                        lesson={currentLesson}
                    />
                }
            />

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "viewlesson"}
                close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentLesson(null) }}
                content={
                   <LessonDetails
                   close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentLesson(null) }}
                   lesson={currentLesson}
                   />
                }
            />

            <CustomOffCanvas
                open={viewComments?.state && viewComments?.lessonId}
                close={() => { setViewComments({ state: false, lessonId: "" }) }}
                content={
                    <Comments
                        close={() => { setViewComments({ state: false, lessonId: "" })}}
                        lessonId={viewComments?.lessonId}
                    />
                }
            />


        </div>
    )
}

export default Lessons